import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-delete-reminder-warning",
	templateUrl: "./delete-reminder-warning.component.html",
	styleUrls: ["./delete-reminder-warning.component.css"],
})
export class DeleteReminderWarningComponent implements OnInit {
	constructor(public ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	///////////////////////////////
	// Buttons
	///////////////////////////////
	onYes() {
		this.ref.close(1);
	}

	onNo() {
		this.ref.close(0);
	}

	onCancel() {
		this.ref.close(-1);
	}

	///////////////////////////////
}
